import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'

import Language from '@/page/language'
import Faq from '@/page/faq'
import Guidance from '@/page/guidance'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/login'
import otp from '@/page/otp'
import land from '@/page/land'
import landNew from '@/page/landNew'
import generateImage from '@/page/generateImage'
import picture from '@/page/picture'
import petPicture from '@/page/petPicture'
import sexPicture from '@/page/sexPicture2'
import sexPicture2 from '@/page/sexPicture2'
import cartoonYourself from '@/page/cartoonYourself'
import idCard from '@/page/idcard'

import purchaseChances from '@/page/purchaseChances'
import purchaseChances2 from '@/page/purchaseChances2'
import Invitation from '@/page/invitation'
import billing from '@/page/billing'
import history from '@/page/history'
import snapbot from '@/page/snapbot'
import oldPicColor from '@/page/oldPicColor'
import Trending from '@/page/Trending'
import bgFusion from '@/page/bgFusion'
import changeHairstyle from '@/page/changeHairstyle'
import longHairEffects from '@/page/longHairEffects'
import imageToVideo from '@/page/imageToVideo'
import image2ToVideo from '@/page/image2ToVideo'
import shootToVideo from '@/page/shootToVideo'
import shootToVideo2 from '@/page/shootToVideo2'
import wordToVideo from '@/page/wordToVideo'
import aiDressUp from '@/page/aiDressUp'
import singleheart from '@/page/singleheart'
import aiVividScene from '@/page/aiVividScene'
import spin from '@/page/spin'
import faceImage from '@/page/faceImage'
import topic from '@/page/topic'
import error from '@/page/error'

Vue.use(Router)

export default new Router({

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		}
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
   /* {
		path: '/login-new',
		name: 'login',
		component: LoginNew,
		meta: {
			title: 'LoginNew'
		}
    },*/
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },{
		path: '/landNew',
		name: 'landNew',
		component: landNew,
		meta: {
			title: 'landNew'
		}
    },{
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },
    {
      path: '/purchaseChances',
      name: 'purchaseChances',
      component: purchaseChances,
      meta: {
        title: 'purchaseChances'
      }
    },
    {
      path: '/purchaseChances2',
      name: 'purchaseChances2',
      component: purchaseChances2,
      meta: {
        title: 'purchaseChances'
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: Invitation,
      meta: {
        title: 'Invitation'
      }
    },{
      path: '/billing',
      name: 'billing',
      component: billing,
      meta: {
        title: 'billing'
      }
    },{
      path: '/history',
      name: 'history',
      component: history,
      meta: {
        title: 'history'
      }
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/guidance',
		name: 'guidance',
		component: Guidance,
		meta: {
			title: ''
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },

    {
      path: '/generateImage',
      name: 'generateImage',
      component: generateImage,
      meta: {
        title: 'Picture Restorer'
      }
    },{
      path: '/picture',
      name: 'picture',
      component: picture,
      meta: {
        title: 'picture'
      }
    },
    {
      path: '/petPicture',
      name: '',
      component: petPicture,
      meta: {
        title: 'petPicture'
      }
    },
    {
      path: '/sexPicture',
      name: '',
      component: sexPicture,
      meta: {
        title: 'sexPicture'
      }
    },
    {
      path: '/sexPicture2',
      name: '',
      component: sexPicture2,
      meta: {
        title: 'sexPicture2'
      }
    },{
      path: '/cartoonYourself',
      name: '',
      component: cartoonYourself,
      meta: {
        title: 'cartoonYourself'
      }
    },
    {
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },
    {
      path: '/idCard',
      name: 'idCard',
      component: idCard,
      meta: {
        title: 'idCard'
      }
    },
    {
      path: '/snapbot',
      name: 'snapbot',
      component: snapbot,
      meta: {
        title: 'snapbot'
      }
    },
    {
      path: '/oldPicColor',
      name: 'oldPicColor',
      component: oldPicColor,
      meta: {
        title: 'oldPicColor'
      }
    },
    {
      path: '/Trending',
      name: 'Trending',
      component: Trending,
      meta: {
        title: 'Trending'
      }
    },
    {
      path: '/bgFusion',
      name: 'bgFusion',
      component: bgFusion,
      meta: {
        title: 'bgFusion'
      }
    },{
      path: '/changeHairstyle',
      name: 'changeHairstyle',
      component: changeHairstyle,
      meta: {
        title: 'changeHairstyle'
      }
    },{
      path: '/longHairEffects',
      name: 'longHairEffects',
      component: longHairEffects,
      meta: {
        title: 'longHairEffects'
      }
    },{
      path: '/imageToVideo',
      name: 'imageToVideo',
      component: imageToVideo,
      meta: {
        title: 'imageToVideo'
      }
    },{
      path: '/shootToVideo',
      name: 'shootToVideo',
      component: shootToVideo,
      meta: {
        title: 'shootToVideo'
      }
    },{
      path: '/shootToVideo2',
      name: 'shootToVideo2',
      component: shootToVideo2,
      meta: {
        title: 'shootToVideo2'
      }
    },{
      path: '/image2ToVideo',
      name: 'image2ToVideo',
      component: image2ToVideo,
      meta: {
        title: 'image2ToVideo'
      }
    },{
      path: '/wordToVideo',
      name: 'wordToVideo',
      component: wordToVideo,
      meta: {
        title: 'wordToVideo'
      }
    },{
      path: '/aiDressUp',
      name: 'aiDressUp',
      component: aiDressUp,
      meta: {
        title: 'aiDressUp'
      }
    },{
      path: '/singleheart',
      name: 'singleheart',
      component: singleheart,
      meta: {
        title: 'singleheart'
      }
    },{
      path: '/aiVividScene',
      name: 'aiVividScene',
      component: aiVividScene,
      meta: {
        title: 'aiVividScene'
      }
    },{
      path: '/spin',
      name: 'spin',
      component: spin,
      meta: {
        title: 'spin'
      }
    },{
      path: '/faceImage',
      name: 'faceImage',
      component: faceImage,
      meta: {
        title: 'faceImage'
      }
    },{
      path: '/topic',
      name: 'topic',
      component: topic,
      meta: {
        title: 'topic'
      }
    },{
      path: '/error',
      name: 'error',
      component: error,
      meta: {
        title: 'error'
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js